import { applyMiddleware, combineReducers, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'

import ducksReducers from './ducks'

const middleware = []

export default createStore(combineReducers(ducksReducers), composeWithDevTools(applyMiddleware(...middleware)))
